// extracted by mini-css-extract-plugin
export var menuIcon = "_ug-0";
export var menuIconInline = "_ug-1";